import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BounceLoader } from "react-spinners"; // Import the spinner
import { validateInput } from "../../helpers/helper";
import { viewDoc } from "../../service/sharing";

const EmailEntryScreen = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [fileUrl, setFileUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { param } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      if (param) {
        try {
          console.log("param", param)
          const result = await viewDoc(param);

          if (result.privacy === "public" && result.fileUrl) {
            window.open(result.fileUrl, "_self");
          } else if (
            result.privacy === "custom" ||
            result.privacy === "only_me"
          ) {
            setLoading(false);
          } else {
            setLoading(false);
          }
        } catch (error) {
          console.error("Error fetching document:", error);
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };
    fetchData();
  }, [param]);

  const handleNext = async () => {
    if (email) {
      const isValid = await validateInput(email);
      if (isValid) {
        try {
          setLoading(true);
          const result = await viewDoc(param, { email });

          if (result === "success") {
            navigate("/otp-entry", { state: { email: email, param: param } });
          } else {
            setError("Invalid email or access denied");
          }
        } catch (error) {
          setError("Invalid email or access denied");
        } finally {
          setLoading(false);
        }
      } else {
        setError("Please enter a valid email");
      }
    } else {
      setError("Email cannot be empty");
    }
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setError("");
  };

  const isButtonDisabled = !email;

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        {loading ? (
          <div style={styles.loaderContainer}>
            <BounceLoader color="#000" />
          </div>
        ) : (
          !fileUrl && (
            <>
              <h2 style={styles.title}>Enter your email</h2>
              <div style={styles.inputContainer}>
                <label htmlFor="email" style={styles.label}>
                  Email
                </label>
                <input
                  id="email"
                  type="email"
                  placeholder="Enter email"
                  value={email}
                  onChange={handleEmailChange}
                  style={styles.input}
                />
                {error && <p style={styles.error}>{error}</p>}
              </div>
              <button
                onClick={handleNext}
                style={{
                  ...styles.button,
                  ...(isButtonDisabled ? styles.buttonDisabled : {}),
                }}
                disabled={isButtonDisabled}
              >
                Next
              </button>
            </>
          )
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    backgroundColor: "#f0f2f5",
    padding: "16px",
  },
  card: {
    backgroundColor: "#fff",
    padding: "40px",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
    maxWidth: "500px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  title: {
    marginBottom: "24px",
    fontSize: "24px",
    color: "#333",
    fontFamily: "Arial, sans-serif",
  },
  inputContainer: {
    position: "relative",
    marginBottom: "40px",
  },
  label: {
    position: "absolute",
    top: "50%",
    left: "16px",
    transform: "translateY(-50%)",
    color: "#333",
    fontSize: "16px",
    pointerEvents: "none",
    fontFamily: "Arial, sans-serif",
  },
  input: {
    padding: "12px 20px 12px 80px",
    fontSize: "16px",
    width: "100%",
    borderRadius: "20px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
    outline: "none",
    transition: "border-color 0.3s ease",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  },
  button: {
    padding: "12px 24px",
    fontSize: "16px",
    color: "#fff",
    backgroundColor: "black",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    alignSelf: "center",
  },
  buttonDisabled: {
    backgroundColor: "#ccc",
    cursor: "not-allowed",
    opacity: 0.6,
  },
  error: {
    color: "red",
    fontSize: "14px",
    marginTop: "8px",
    position: "absolute",
    left: "0",
    width: "100%",
    textAlign: "left",
  },
  loaderContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
};

export default EmailEntryScreen;
